import { ConditionType, defaultOperator } from '@fabric-ui/components';
import { FormatterType } from '@fabric-ui/components/Table';
import { NullValues } from '../../constants';
import { isExplodeExpression } from '../../CustomDashboardsUtils/expressionUtils';

export const getOperator = (val: any, type?: string, dimsMap?: Record<string, any>, dim?: string) => {
  if (NullValues.includes(val)) {
    return 'empty';
  }
  if (type === FormatterType.date || type === FormatterType.historicDate) {
    return defaultOperator[ConditionType.date];
  }
  if (type === FormatterType.array) {
    return dimsMap && dim && isExplodeExpression(dimsMap[dim]?.expression) ? 'in' : 'arrayEquals';
  }
  return 'equals';
};
